// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"4229a770","672":"295596f6","1184":"ce57b38a","1596":"b85bc2d5","2032":"06afb6ba","2489":"4229a770","2652":"4229a770","2881":"4229a770"}[chunkId] + ".chunk.css";
};